import React from 'react';
import './CustomFocus.css';

const EXPLORATION_MODES = [
  {
    key: 'brainstorm',
    label: 'Brainstorm',
    description: 'Generate possibilities and "what if" variations',
    icon: 'Lightbulb',
  },
  {
    key: 'develop',
    label: 'Develop',
    description: 'Go deeper, find implications and texture',
    icon: 'Layers',
  },
  {
    key: 'define',
    label: 'Define',
    description: 'Establish facts and lock things down',
    icon: 'CheckSquare',
  },
  {
    key: 'test',
    label: 'Test',
    description: 'Stress-test ideas and find weaknesses',
    icon: 'FlaskConical',
  },
];

/**
 * ExplorationModeSelector - Radio buttons for selecting exploration mode
 *
 * Props:
 * - value: Current selected mode
 * - onChange: Callback when mode changes
 */
export default function ExplorationModeSelector({ value, onChange }) {
  return (
    <div className="exploration-mode-selector">
      <label className="exploration-mode-label">Exploration Mode</label>
      <div className="exploration-mode-options">
        {EXPLORATION_MODES.map((mode) => (
          <label
            key={mode.key}
            className={`exploration-mode-option ${value === mode.key ? 'selected' : ''}`}
          >
            <input
              type="radio"
              name="exploration_mode"
              value={mode.key}
              checked={value === mode.key}
              onChange={(e) => onChange(e.target.value)}
            />
            <span className="exploration-mode-content">
              <span className="exploration-mode-name">{mode.label}</span>
              <span className="exploration-mode-desc">{mode.description}</span>
            </span>
          </label>
        ))}
      </div>
    </div>
  );
}

export { EXPLORATION_MODES };
